import { Link } from "react-router-dom";
import { fileUrl, dollars } from "@/lib/api";
import { Play } from "lucide-react";

export function AlbumCard({ album, onPlay }) {
  return (
    <div data-testid={`album-card-${album.id}`}
         className={`group border hover-lift bg-[#121212] ${album.is_free ? "border-[#FF4500] shadow-[0_0_24px_-8px_rgba(255,69,0,0.6)]" : "border-[#2A2A2A]"}`}>
      <Link to={`/album/${album.id}`} className="block relative aspect-square overflow-hidden bg-neutral-800">
        {album.cover_path ? (
          <img src={fileUrl(album.cover_path)} alt={album.title} className="h-full w-full object-cover" />
        ) : (
          <div className="h-full w-full grid place-items-center font-display text-4xl text-[#FF4500]/40">{album.title?.[0]?.toUpperCase()}</div>
        )}
        {album.is_free && (
          <div className="absolute top-2 right-2 rotate-6 bg-[#FF4500] text-black font-display font-black text-lg tracking-tight px-2.5 py-0.5 shadow-xl">
            FREE
          </div>
        )}
        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity grid place-items-center">
          <div className="h-12 w-12 grid place-items-center bg-[#FF4500] text-black">
            <Play className="h-6 w-6" fill="currentColor" />
          </div>
        </div>
      </Link>
      <div className="p-3 md:p-4">
        <div className="flex items-baseline justify-between gap-2">
          <Link to={`/album/${album.id}`} className="font-display font-medium truncate hover:text-[#FF4500] transition-colors">{album.title}</Link>
          <span data-testid={`album-price-${album.id}`} className={`font-mono text-xs ${album.is_free ? "text-[#FF4500] font-black" : "text-[#FF4500]"}`}>
            {album.is_free ? "FREE" : dollars(album.price_cents || 1500)}
          </span>
        </div>
        <div className="font-mono text-[10px] uppercase tracking-widest text-gray-500 mt-1 truncate">{album.artist_name}</div>
      </div>
    </div>
  );
}
